import { request } from "./http.js";
//哈仲裁中文版
class Service {
  //注册
  // static async getregist(data) {
  //   return request("account/regist", data);
  // }
  //手机号注册
  static async getregist(data) {
    return request("account/regist/mobile", data);
  }
  //注册验证码接口
  static async getsmsregist(data) {
    return request("account/sms/regist", data);
  }
  //修改密码接口
  static async getforget(data) {
    return request("account/forget", data);
  }
  //修改密码验证码接口
  static async getsmsforget(data) {
    return request("account/sms/forget", data);
  }
  //手机验证码接口
  static async getsmslogin(data) {
    return request("account/sms/login", data);
  }
  //手机号登录接口
  static async getloginmobile(data) {
    return request("account/login/mobile", data);
  }
  //修改密码接口
  static async getchangePass(data) {
    return request("account/changePass", data);
  }
  
  //修改手机号提交接口
  static async getchangeMobile(data) {
    return request("account/changeMobile", data);
  }
  //修改手机号验证码交接口
  static async getsmsbinding(data) {
    return request("account/sms/binding", data);
  }
  //登录
  static async getlogin(data) {
    return request("account/login", data);
  }
  //退出登录
  static async getlogout(data) {
    return request("account/logout", data);
  }
  //用户信息
  static async getinfo(data) {
    return request("user/info", data);
  }
  //编辑信息
  static async getinfoinfo(data) {
    return request("user/info/save", data);
  }
  //哈仲仲裁员申请表列表
  static async getlistsindex(data) {
    return request("form/lists/index", data);
  }
  //详情回显
  static async getcmsdetail(data) {
    return request("cms/detail", data);
  }
  //承诺书提交
  static async getmaincreate(data) {
    return request("form/main/create", data);
  }
  //表单头部导航
  static async getmainnav(data) {
    return request("form/main/nav", data);
  }
  //个人信息表单详情
  static async getbasicdetail(data) {
    return request("form/basic/detail", data);
  }
  //个人信息表单文字信息
  static async getbasicform(data) {
    return request("form/basic/form", data);
  }
  //个人信息表单保存
  static async getbasicstorage(data) {
    return request("form/basic/storage", data);
  }
  //个人信息表单下一步
  static async getbasicsave(data) {
    return request("form/basic/save", data);
  }
  //个人信息表单导入
  static async getbasicimport(data) {
    return request("form/basic/import", data);
  }
  //联系方式表单详情
  static async getcontactdetail(data) {
    return request("form/contact/detail", data);
  }
  //联系方式表单文字信息
  static async getcontactform(data) {
    return request("form/contact/form", data);
  }
  //联系方式表单保存
  static async getcontactstorage(data) {
    return request("form/contact/storage", data);
  }
  //联系方式表单下一步
  static async getcontactsave(data) {
    return request("form/contact/save", data);
  }
  //联系方式表单提示文字
  static async getcontactform_info(data) {
    return request("form/contact/form_info", data);
  }
  //联系方式表单导入
  static async getcontactimport(data) {
    return request("form/contact/import", data);
  }
  //仲裁员任职条件表单详情
  static async getjob_requiredetail(data) {
    return request("form/job_require/detail", data);
  }
  //仲裁员任职条件表单文字信息
  static async getjob_requireform(data) {
    return request("form/job_require/form", data);
  }
  //仲裁员任职条件表单保存
  static async getjob_requirestorage(data) {
    return request("form/job_require/storage", data);
  }
  //仲裁员任职条件表单下一步
  static async getjob_requiresave(data) {
    return request("form/job_require/save", data);
  }
  //仲裁员任职条件表单提示文字
  static async getjob_requireform_info(data) {
    return request("form/job_require/form_info", data);
  }
  //仲裁员任职条件表单导入
  static async getjob_requireimport(data) {
    return request("form/job_require/import", data);
  }
  //专业背景表单详情
  static async getmajor_bgdetail(data) {
    return request("form/major_bg/detail", data);
  }
  //专业背景表单文字信息
  static async getmajor_bgform(data) {
    return request("form/major_bg/form", data);
  }
  //专业背景表单保存
  static async getmajor_bgstorage(data) {
    return request("form/major_bg/storage", data);
  }
  //专业背景表单下一步
  static async getmajor_bgsave(data) {
    return request("form/major_bg/save", data);
  }
  //专业背景表单提示文字
  static async getmajor_bgform_info(data) {
    return request("form/major_bg/form_info", data);
  }
  //专业背景表单下拉选项
  static async getmajor_bgoptions(data) {
    return request("form/major_bg/options", data);
  }
  //专业背景表单导入
  static async getmajor_bgimport(data) {
    return request("form/major_bg/import", data);
  }
  //教育背景表单详情
  static async getedu_bgdetail(data) {
    return request("form/edu_bg/detail", data);
  }
  //教育背景表单文字信息
  static async getmedu_bgform(data) {
    return request("form/edu_bg/form", data);
  }
  //教育背景表单保存
  static async getedu_bgstorage(data) {
    return request("form/edu_bg/storage", data);
  }
  //教育背景表单下一步
  static async getedu_bgsave(data) {
    return request("form/edu_bg/save", data);
  }
  //教育背景表单提示文字
  static async getedu_bgform_info(data) {
    return request("form/edu_bg/form_info", data);
  }
  //教育背景表单导入
  static async getedu_bgimport(data) {
    return request("form/edu_bg/import", data);
  }
  //专业技能表单详情
  static async getskilldetail(data) {
    return request("form/skill/detail", data);
  }
  //专业技能表单文字信息
  static async geskillform(data) {
    return request("form/skill/form", data);
  }
  //专业技能表单保存
  static async geskillstorage(data) {
    return request("form/skill/storage", data);
  }
  //专业技能表单下一步
  static async getskillsave(data) {
    return request("form/skill/save", data);
  }
  //专业技能表单提示文字
  static async getskillform_info(data) {
    return request("form/skill/form_info", data);
  }
  //专业技能表单导入
  static async getskillimport(data) {
    return request("form/skill/import", data);
  }
  //工作经历表单详情
  static async getwork_expdetail(data) {
    return request("form/work_exp/detail", data);
  }
  //工作经历表单文字信息
  static async geswork_expform(data) {
    return request("form/work_exp/form", data);
  }
  //工作经历表单保存
  static async geswork_expstorage(data) {
    return request("form/work_exp/storage", data);
  }
  //工作经历表单下一步
  static async getwork_expsave(data) {
    return request("form/work_exp/save", data);
  }
  //工作经历表单提示文字
  static async getwork_expform_info(data) {
    return request("form/work_exp/form_info", data);
  }
  
  //工作经历表单导入
  static async getwork_expimpor(data) {
    return request("form/work_exp/import", data);
  }
  
  //建议设想表单详情
  static async getsuggestdetail(data) {
    return request("form/suggest/detail", data);
  }
  //建议设想表单文字信息
  static async gessuggestform(data) {
    return request("form/suggest/form", data);
  }
  //建议设想表单保存
  static async gessuggeststorage(data) {
    return request("form/suggest/storage", data);
  }
  //建议设想表单下一步
  static async getsuggestsave(data) {
    return request("form/suggest/save", data);
  }
  //建议设想表单提示文字
  static async getsuggestform_info(data) {
    return request("form/suggest/form_info", data);
  }
  //表单确认提交
  static async getmainsubmit(data) {
    return request("form/main/submit", data);
  }
  
	
}
export default {
  Service,
};
